import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EM_SALES_REPORTS_SLICE_NAME } from './constants';
import {
	TEmSalesReportDownloadFileRequest,
	TEmSalesReportInvoicingFeeTypesResponse,
	TEmSalesReportProcessFileRequest,
	TEmSalesReportProcessFileResponse,
	TEmSalesReportProcessingTypesResponse,
	TEmSalesReportUploadedFilesRequest,
	TEmSalesReportUploadedFilesResponse,
	TEmSalesReportsStore,
} from './types';

const initialState: TEmSalesReportsStore = {
	uploadedFiles: null,
	uploadedFilesLoading: false,

	processingTypes: null,
	processingTypesLoading: false,

	processFileLoading: false,
	processFileSuccess: false,
	processFileError: null,

	downloadFileLoading: false,

	invoicingFeeTypes: null,
	invoicingFeeTypesLoading: false,
};

const emSalesReports = createSlice({
	name: EM_SALES_REPORTS_SLICE_NAME,
	initialState,
	reducers: {
		getUploadedFilesRequest: (
			state,
			_action: PayloadAction<TEmSalesReportUploadedFilesRequest>,
		) => {
			state.uploadedFilesLoading = true;
		},
		getUploadedFilesSuccess: (
			state,
			action: PayloadAction<TEmSalesReportUploadedFilesResponse>,
		) => {
			state.uploadedFiles = action.payload;
			state.uploadedFilesLoading = false;
		},
		getUploadedFilesFailure: (state) => {
			state.uploadedFilesLoading = false;
		},
		clearUploadedFiles: (state) => {
			state.uploadedFiles = null;
		},

		getProcessingTypesRequest: (state) => {
			state.processingTypesLoading = true;
		},
		getProcessingTypesSuccess: (
			state,
			action: PayloadAction<TEmSalesReportProcessingTypesResponse>,
		) => {
			state.processingTypes = action.payload;
			state.processingTypesLoading = false;
		},
		getProcessingTypesFailure: (state) => {
			state.processingTypesLoading = false;
		},

		processFileRequest: (state, _action: PayloadAction<TEmSalesReportProcessFileRequest>) => {
			state.processFileLoading = true;
			state.processFileSuccess = false;
			state.processFileError = null;
		},
		processFileSuccess: (state, _action: PayloadAction<TEmSalesReportProcessFileResponse>) => {
			state.processFileLoading = false;
			state.processFileSuccess = true;
			state.processFileError = null;
		},
		processFileFailure: (state, action: PayloadAction<string>) => {
			state.processFileLoading = false;
			state.processFileSuccess = false;
			state.processFileError = action.payload;
		},
		resetProcessFileSuccess: (state) => {
			state.processFileSuccess = false;
			state.processFileError = null;
		},

		downloadFileRequest: (state, _action: PayloadAction<TEmSalesReportDownloadFileRequest>) => {
			state.downloadFileLoading = true;
		},
		downloadFileSuccess: (state) => {
			state.downloadFileLoading = false;
		},
		downloadFileFailure: (state) => {
			state.downloadFileLoading = false;
		},

		getInvoicingFeeTypesRequest: (state) => {
			state.invoicingFeeTypesLoading = true;
		},
		getInvoicingFeeTypesSuccess: (
			state,
			action: PayloadAction<TEmSalesReportInvoicingFeeTypesResponse>,
		) => {
			state.invoicingFeeTypes = action.payload;
			state.invoicingFeeTypesLoading = false;
		},
		getInvoicingFeeTypesFailure: (state) => {
			state.invoicingFeeTypesLoading = false;
		},

		emSalesReportsInitState: () => initialState,
	},
});

export const {
	getUploadedFilesRequest,
	getUploadedFilesSuccess,
	getUploadedFilesFailure,
	clearUploadedFiles,
	getProcessingTypesRequest,
	getProcessingTypesSuccess,
	getProcessingTypesFailure,
	processFileRequest,
	processFileSuccess,
	processFileFailure,
	resetProcessFileSuccess,
	downloadFileRequest,
	downloadFileSuccess,
	downloadFileFailure,
	getInvoicingFeeTypesRequest,
	getInvoicingFeeTypesSuccess,
	getInvoicingFeeTypesFailure,
	emSalesReportsInitState,
} = emSalesReports.actions;

export default emSalesReports.reducer;
